import { InvoiceRepository } from "../../repositories/InvoiceRepository";
import {
  InvoiceOperationResult,
  InvoiceDataEntity,
} from "../../entities/InvoiceEntity";

/**
 * Update Invoice JSON Use Case
 * Updates invoice JSON data (for auto-save and manual edits)
 */
export class UpdateInvoiceJsonUseCase {
  constructor(private repository: InvoiceRepository) {}

  async execute(
    invoiceId: number,
    invoiceData: InvoiceDataEntity
  ): Promise<InvoiceOperationResult> {
    // Validate inputs
    // if (!invoiceId || invoiceId <= 0) {
    //   throw new Error("Valid invoice ID is required");
    // }

    // if (!invoiceData) {
    //   throw new Error("Invoice data is required");
    // }

    // // Validate required fields in invoice data
    // if (!invoiceData.customer_id || invoiceData.customer_id.trim() === "") {
    //   throw new Error("Customer ID is required in invoice data");
    // }

    // if (!invoiceData.invoice_number || invoiceData.invoice_number.trim() === "") {
    //   throw new Error("Invoice number is required");
    // }

    return await this.repository.updateInvoiceJson(invoiceId, invoiceData);
  }
}
